import { render, staticRenderFns } from "./pageFour.vue?vue&type=template&id=4a3c3044&scoped=true&"
import script from "./pageFour.vue?vue&type=script&lang=js&"
export * from "./pageFour.vue?vue&type=script&lang=js&"
import style0 from "./pageFour.vue?vue&type=style&index=0&id=4a3c3044&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3c3044",
  null
  
)

export default component.exports